import { notify } from 'utils/reduxUtils';

export const types = {
  UPDATE_LEAD_TIME_UNIT_ERROR:
    'settings/digitalQuote/UPDATE_LEAD_TIME_UNIT_ERROR',
  UPDATE_LEAD_TIME_UNIT_REQUEST:
    'settings/digitalQuote/UPDATE_LEAD_TIME_UNIT_REQUEST',
  UPDATE_LEAD_TIME_UNIT_SUCCESS:
    'settings/digitalQuote/UPDATE_LEAD_TIME_UNIT_SUCCESS',
};

export const updateLeadTimeUnit = {
  error: notify(
    (error) => ({
      type: types.UPDATE_LEAD_TIME_UNIT_ERROR,
      payload: error,
    }),
    "Can't update lead time unit",
  ),
  request: ({ leadTimeUnit }) => ({
    type: types.UPDATE_LEAD_TIME_UNIT_REQUEST,
    payload: { leadTimeUnit },
  }),
  success: notify(
    () => ({
      type: types.UPDATE_LEAD_TIME_UNIT_SUCCESS,
    }),
    'Lead time unit updated successfully',
  ),
};
